import { Product } from '@/store/modules/product';
import { ElementMenuItem } from '../elementMenuItem';
import { Vector2 } from '@babylonjs/core';
import { ElementType, SpecyficType } from '../element';
import { IElementsProvider } from './IElementsProvider';

class ChestFurnitureElementsProvider implements IElementsProvider {
    public get(product: Product): ElementMenuItem[] {
        const depth = product.depth;
        const fronts: ElementMenuItem[] = [
            new ElementMenuItem(
                'ikony_Front_1x1.svg',
                'front1x1',
                'f_1x1_?.gltf',
                '',
                'f_1x1_?_light.jpg',
                new Vector2(1, 1),
                ElementType.FRONT,
                undefined,
                [],
                null,
                true,
            ),
            new ElementMenuItem(
                'ikony_Front_2x1.svg',
                'front1x2',
                'f_1x2_?.gltf',
                '',
                'f_1x2_?_light.jpg',
                new Vector2(1, 2),
                ElementType.FRONT,
                undefined,
                [],
                null,
                true,
            ),
            new ElementMenuItem(
                'ikony_Front_3x1.svg',
                'front1x3',
                'f_1x3_?.gltf',
                '',
                'f_1x3_?_light.jpg',
                new Vector2(1, 3),
                ElementType.FRONT,
                undefined,
                [],
                null,
                true,
            ),
            new ElementMenuItem(
                'ikony_Front_4x1.svg',
                'front1x4',
                'f_1x4_?.gltf',
                '',
                'f_1x4_?_light.jpg',
                new Vector2(1, 4),
                ElementType.FRONT,
                undefined,
                [],
                null,
                true,
            ),
        ];
        const doubleFronts: ElementMenuItem[] = [
            new ElementMenuItem(
                'ikony_Front_1x2.svg',
                'front2x1',
                '',
                '',
                '',
                new Vector2(2, 1),
                ElementType.FRONT,
                undefined,
                [new ElementMenuItem(
                    '',
                    '',
                    'f_1x1_?.gltf',
                    '',
                    'f_1x1_?_light.jpg',
                    new Vector2(1, 1),
                    ElementType.FRONT,
                ),
                new ElementMenuItem(
                    '',
                    '',
                    'f_1x1_?.gltf',
                    '',
                    'f_1x1_?_light.jpg',
                    new Vector2(1, 1),
                    ElementType.FRONT,
                )],
                null,
                true
            ),
            new ElementMenuItem(
                'ikony_Front_2x2.svg',
                'front2x2',
                '',
                '',
                '',
                new Vector2(2, 2),
                ElementType.FRONT,
                undefined,
                [new ElementMenuItem(
                    '',
                    '',
                    'f_1x2_?.gltf',
                    '',
                    'f_1x2_?_light.jpg',
                    new Vector2(1, 2),
                    ElementType.FRONT,
                ),
                new ElementMenuItem(
                    '',
                    '',
                    'f_1x2_?.gltf',
                    '',
                    'f_1x2_?_light.jpg',
                    new Vector2(1, 2),
                    ElementType.FRONT,
                )],
                null,
                true
            ),
            new ElementMenuItem(
                'ikony_Front_3x2.svg',
                'front2x3',
                '',
                '',
                '',
                new Vector2(2, 3),
                ElementType.FRONT,
                undefined,
                [new ElementMenuItem(
                    '',
                    '',
                    'f_1x3_?.gltf',
                    '',
                    'f_1x3_?_light.jpg',
                    new Vector2(1, 3),
                    ElementType.FRONT,
                ),
                new ElementMenuItem(
                    '',
                    '',
                    'f_1x3_?.gltf',
                    '',
                    'f_1x3_?_light.jpg',
                    new Vector2(1, 3),
                    ElementType.FRONT,
                )],
                null,
                true
            ),
            new ElementMenuItem(
                'ikony_Front_4x2.svg',
                'front2x4',
                '',
                '',
                '',
                new Vector2(2, 4),
                ElementType.FRONT,
                undefined,
                [new ElementMenuItem(
                    '',
                    '',
                    'f_1x4_?.gltf',
                    '',
                    'f_1x4_?_light.jpg',
                    new Vector2(1, 4),
                    ElementType.FRONT,
                ),
                new ElementMenuItem(
                    '',
                    '',
                    'f_1x4_?.gltf',
                    '',
                    'f_1x4_?_light.jpg',
                    new Vector2(1, 4),
                    ElementType.FRONT,
                )],
                null,
                true
            ),
        ];
        const drawers: ElementMenuItem[] = [
            new ElementMenuItem(
                'ikony_Szuflady_male.svg',
                'shortDrawer',
                `s_${depth}_1.gltf`,
                '',
                `s_${depth}_1_komora_light.jpg`,
                new Vector2(1, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
                [],
                ['tooltipSmallDrower_0', 'tooltipSmallDrower_1'],
            ),
            new ElementMenuItem(
                'ikony_Szuflady_duze.svg',
                'longDrawer',
                `s_${depth}_2.gltf`,
                '',
                `s_${depth}_2_komora_light.jpg`,
                new Vector2(2, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
                [],
                ['tooltipSmallDrower_0', 'tooltipSmallDrower_1'],
            ),
        ];
        const hangers: ElementMenuItem[] = [
            new ElementMenuItem(
                'ikony_Drazek_maly.svg',
                'shortHanger',
                `d_${depth}_1.gltf`,
                '',
                `d_${depth}_1_mesh_light.jpg`,
                new Vector2(1, 2),
                ElementType.INSIDE,
                SpecyficType.HANGER,
            ),
            new ElementMenuItem(
                'ikony_Drazek_duzy.svg',
                'longHanger',
                `d_${depth}_2.gltf`,
                '',
                `d_${depth}_2_mesh_light.jpg`,
                new Vector2(2, 2),
                ElementType.INSIDE,
                SpecyficType.HANGER,
            ),
        ];
        const shelves: ElementMenuItem[] = [
            new ElementMenuItem(
                'ikony_Polka_mala.svg',
                'shortShelf',
                `polka_${depth}_1.gltf`,
                '',
                `polka_${depth}_1_mesh_light.jpg`,
                new Vector2(1, 0),
                ElementType.INSIDE,
                SpecyficType.SHELF,
            ),
            new ElementMenuItem(
                'ikony_Polka_duza.svg',
                'longShelf',
                `polka_${depth}_2.gltf`,
                '',
                `polka_${depth}_2_mesh_light.jpg`,
                new Vector2(2, 0),
                ElementType.INSIDE,
                SpecyficType.SHELF,
            ),
        ];
        const allElements: ElementMenuItem[] = [];

        allElements.push(...shelves);
        if (product.depth > 455) {
            allElements.push(...hangers);
        }
        if (product.depth > 355 && !product.isLevelRaiser) {
            allElements.push(...drawers);
        }
        allElements.push(...fronts);
        allElements.push(...doubleFronts);

        return allElements.filter((x) =>
            x.shape.x <= product.shape.x &&
            x.shape.y <= product.shape.y,
        );
    }
}

export const chestFurnitureElementsProvider = new ChestFurnitureElementsProvider();
